var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "status-container" }, [
      _c("div", { class: { active: _vm.status >= 1 } }, [
        _c("span", [_vm._v("1")]),
        _vm._v(" "),
        _c("span", [_vm._v("Create Order")]),
      ]),
      _vm._v(" "),
      _c("div", { class: { active: _vm.status >= 2 } }),
      _vm._v(" "),
      _c("div", { class: { active: _vm.status >= 2 } }, [
        _c("span", [_vm._v("2")]),
        _vm._v(" "),
        _c("span", [_vm._v("Payment Information")]),
      ]),
      _vm._v(" "),
      _c("div", { class: { active: _vm.status == 3 } }),
      _vm._v(" "),
      _c("div", { class: { active: _vm.status == 3 } }, [
        _c("span", [_vm._v("3")]),
        _vm._v(" "),
        _c("span", [_vm._v("Order Tracking")]),
      ]),
    ]),
    _vm._v(" "),
    _vm.status == 1
      ? _c(
          "div",
          { staticStyle: { display: "flex", "justify-content": "center" } },
          [
            _c(
              "div",
              { staticClass: "card p-6", staticStyle: { width: "50%" } },
              [
                _c("span", { staticClass: "subtitle" }, [
                  _vm._v("Create New Order"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "3rem" } },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-3-1 gap-1rem" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.order.clientNumber,
                            expression: "order.clientNumber",
                          },
                        ],
                        staticClass: "filter-item-content",
                        attrs: {
                          type: "text",
                          placeholder: "Leave empty to auto-generate",
                        },
                        domProps: { value: _vm.order.clientNumber },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order,
                                "clientNumber",
                                $event.target.value
                              )
                            },
                            function (event) {
                              return (_vm.order.clientNumber = _vm.sanitize(
                                event.target.value
                              ))
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-outline btn-outline-light",
                          on: {
                            click: function ($event) {
                              return _vm.generateClientNumber()
                            },
                          },
                        },
                        [_vm._v("Generate")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("small", [_vm._v("If empty, will be auto-generated")]),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "info-clientNumber-link",
                          triggers: "hover",
                          placement: "bottom",
                          "custom-class": "popover-info",
                        },
                      },
                      [
                        _c("div", [_vm._v("Client Number (required)")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "CRITICAL: Client numbers are REQUIRED for all customers. VIBANs are allocated ONLY to client numbers, never to order references. If empty, a client number is auto-generated."
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "1rem" } },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-3-1 gap-1rem" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.order.reference,
                            expression: "order.reference",
                          },
                        ],
                        staticClass: "filter-item-content",
                        attrs: {
                          type: "text",
                          placeholder: "Leave empty to auto-generate",
                        },
                        domProps: { value: _vm.order.reference },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order,
                                "reference",
                                $event.target.value
                              )
                            },
                            function (event) {
                              return (_vm.order.reference = _vm.sanitize(
                                event.target.value
                              ))
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-outline btn-outline-light",
                          on: {
                            click: function ($event) {
                              return _vm.generateReference()
                            },
                          },
                        },
                        [_vm._v("Generate")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("small", [_vm._v("If empty, will be auto-generated")]),
                    _vm._v(" "),
                    _vm.orderReferenceError
                      ? _c("small", { staticStyle: { color: "#e7000b" } }, [
                          _vm._v(_vm._s(_vm.orderReferenceError)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "info-reference-link",
                          triggers: "hover",
                          placement: "bottom",
                          "custom-class": "popover-info",
                        },
                      },
                      [
                        _c("div", [_vm._v("Order Reference")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Optional identifier for this specific order. Used in payment remittance info to help disambiguate when multiple orders have the same amount and date. VIBANs are NOT allocated to order references."
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "1rem" } },
                  [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v("Amount (EUR)*"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "filter-item-content",
                      attrs: { type: "number", placeholder: "0.00" },
                      on: {
                        input: function (event) {
                          return _vm.handleAmount(event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.amountError
                      ? _c("small", { staticStyle: { color: "#e7000b" } }, [
                          _vm._v(_vm._s(_vm.amountError)),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "1rem" } },
                  [
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("Order Date"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item-content" }, [
                      _vm._v(_vm._s(_vm.formatDate(new Date()))),
                    ]),
                    _vm._v(" "),
                    _c("small", [_vm._v("Automatically set to today")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "1rem" } },
                  [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v("Expected Payment Term"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "filter-item-content d-flex justify-content-between py-2 px-3",
                            attrs: {
                              id: "payment-term-picker-link",
                              href: "#",
                            },
                          },
                          [
                            _c("span", { staticClass: "fixed-span-size" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    this.order.executionDate == 0
                                      ? "Instant"
                                      : this.order.executionDate
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa-light fa-chevron-down",
                              attrs: {
                                size: "17px",
                                id: "action-type-chevron",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            attrs: {
                              target: "payment-term-picker-link",
                              triggers: "focus",
                              placement: "bottom",
                              "custom-class": "popover",
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  class: [
                                    "popover-option",
                                    {
                                      "popover-option-selected":
                                        this.order.executionDate == 0,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.order.executionDate = 0
                                    },
                                  },
                                },
                                [_vm._v("Instant")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "popover-option",
                                    {
                                      "popover-option-selected":
                                        this.order.executionDate == 15,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.order.executionDate = 15
                                    },
                                  },
                                },
                                [_vm._v("15 Days")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "popover-option",
                                    {
                                      "popover-option-selected":
                                        this.order.executionDate == 30,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.order.executionDate = 30
                                    },
                                  },
                                },
                                [_vm._v("30 Days")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "popover-option",
                                    {
                                      "popover-option-selected":
                                        this.order.executionDate == 45,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.order.executionDate = 45
                                    },
                                  },
                                },
                                [_vm._v("45 Days")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "popover-option",
                                    {
                                      "popover-option-selected":
                                        this.order.executionDate == 60,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.order.executionDate = 60
                                    },
                                  },
                                },
                                [_vm._v("60 Days")]
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "grid", "margin-top": "1rem" } },
                  [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v("Customer Email (optional)"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "filter-item-content",
                      attrs: {
                        type: "text",
                        placeholder: "customer@example.com",
                      },
                      on: {
                        input: function (event) {
                          return (_vm.order.customerEmail = _vm.sanitize(
                            event.target.value
                          ))
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grid-2-1 gap-1rem mt-2rem" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-dark",
                      on: {
                        click: function ($event) {
                          return _vm.createOrder()
                        },
                      },
                    },
                    [_vm._v("Create Order")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-outline-light",
                      on: {
                        click: function ($event) {
                          return _vm.viewOrder()
                        },
                      },
                    },
                    [_vm._v("View All Orders")]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm.status == 2
      ? _c(
          "div",
          [
            _vm.isAlertOpen
              ? _c("alert-modal", [
                  _c("span", [
                    _c("i", { staticClass: "fa-solid fa-circle-check" }),
                    _vm._v(
                      "New invoice " +
                        _vm._s(this.invoice.InvoiceIdentifier) +
                        " has been successfully created for VIBAN " +
                        _vm._s(this.invoice.VIBAN)
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "grid-3-1 gap-0-2rem" }, [
              _c("div", [
                _c("div", { staticClass: "card p-6" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "subtitle",
                          staticStyle: { "font-weight": "bold" },
                        },
                        [_vm._v("Select Payment Method")]
                      ),
                      _vm._v(" "),
                      _vm.isSelected
                        ? _c(
                            "span",
                            {
                              staticClass: "btn-empty",
                              staticStyle: {
                                color: "#008236",
                                "background-color": "#dcfce7",
                                border: "none",
                                "font-size": "0.9rem",
                              },
                            },
                            [_vm._v("Selected")]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-1-1-1 mt-2rem gap-1rem" }, [
                    _c(
                      "div",
                      {
                        class: ["card p-6", { active: _vm.isSelected }],
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          gap: "1rem",
                        },
                        on: {
                          click: function ($event) {
                            _vm.isSelected = true
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-building",
                          style: {
                            "background-color": _vm.isSelected
                              ? "#155dfc"
                              : "#4a5565",
                            "border-radius": "0.625rem",
                            padding: "1rem",
                            width: "3rem",
                            height: "3rem",
                            color: "white",
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { display: "grid" } }, [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [
                              _vm._v("Digital Credit Transfer "),
                              _vm.isSelected
                                ? _c("i", {
                                    staticClass: "fa-regular fa-circle-check",
                                    staticStyle: { color: "#155dfc" },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("small", [_vm._v("Secure bank transfer")]),
                          _vm._v(" "),
                          _vm._m(2),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._m(4),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isSelected
                  ? _c(
                      "div",
                      {
                        staticClass: "card p-6",
                        staticStyle: { display: "grid", gap: "1rem" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("span", { staticClass: "subtitle" }, [
                              _vm._v("Payment Instructions"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { display: "flex", gap: "1rem" } },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline-light",
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyVIBAN()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-clone",
                                    }),
                                    _vm._v("Copy IBAN"),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline-light",
                                    on: {
                                      click: function ($event) {
                                        return _vm.download()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-light fa-arrow-down-to-bracket",
                                    }),
                                    _vm._v("Download"),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("small", [_vm._v("IBAN")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filter-item-content bordered" },
                            [
                              _c("span", { staticStyle: { color: "black" } }, [
                                _vm._v(
                                  _vm._s(
                                    this.invoice.VIBAN.replace(
                                      /(.{4})(?!$)/g,
                                      "$1 "
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "grid",
                              "grid-template-columns": "1fr 1fr",
                              gap: "1rem",
                            },
                          },
                          [
                            _c("div", [
                              _c("small", [_vm._v("Reference")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-item-content bordered" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(this.invoice.InvoiceIdentifier)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("small", [_vm._v("Amount")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-item-content bordered" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [_vm._v("€" + _vm._s(this.invoice.Amount))]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._m(6),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card p-6",
                  staticStyle: { height: "fit-content" },
                },
                [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v("Order Summary"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mt-2rem",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "border-bottom": "1px solid #0000001a",
                        padding: "0.5rem 0rem",
                        "margin-bottom": "0.5rem",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#4a5565" } }, [
                        _vm._v("Reference:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(_vm._s(this.invoice.InvoiceIdentifier)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "border-bottom": "1px solid #0000001a",
                        padding: "0.5rem 0rem",
                        "margin-bottom": "0.5rem",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#4a5565" } }, [
                        _vm._v("Term:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(
                            this.order.executionDate == 0
                              ? "Instant"
                              : this.order.executionDate + " days"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "border-bottom": "1px solid #0000001a",
                        padding: "0.5rem 0rem",
                        "margin-bottom": "0.5rem",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#4a5565" } }, [
                        _vm._v("Date:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(
                            new Date(
                              this.invoice.PaymentDate
                            ).toLocaleDateString()
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("span", { staticStyle: { color: "#4a5565" } }, [
                        _vm._v("Total:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          "€" + _vm._s(Number(this.invoice.Amount).toFixed(2))
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.isSelected
              ? _c(
                  "div",
                  { staticClass: "grid-1-1 gap-2rem" },
                  [
                    _c("create-payment-modal", {
                      attrs: {
                        payment: {
                          VIBAN: _vm.invoice.VIBAN,
                          reference: _vm.invoice.Reference1,
                          paymentDate: _vm.invoice.PaymentDate,
                          amount: _vm.invoice.Amount,
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-outline btn-dark",
                        on: {
                          click: function ($event) {
                            _vm.status = 3
                          },
                        },
                      },
                      [_vm._v("I have made the transfer → Track Status")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c("div", { staticClass: "card p-6" }, [
          _c("div", { staticClass: "grid-1-1-1" }, [
            _c("div", { staticStyle: { display: "grid" } }, [
              _c("small", [_vm._v("Order Reference")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(this.invoice.InvoiceIdentifier))]),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { display: "grid" } }, [
              _c("small", [_vm._v("Order Amount")]),
              _vm._v(" "),
              _c("span", [
                _vm._v("€" + _vm._s(Number(this.invoice.Amount).toFixed(2))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { display: "grid" } }, [
              _c("small", [_vm._v("Current Status")]),
              _vm._v(" "),
              this.invoice.Status == 0
                ? _c(
                    "span",
                    {
                      staticClass: "btn-selection",
                      staticStyle: {
                        color: "#334155",
                        "background-color": "#f8fafc",
                        "border-color": "#e2e8f0",
                      },
                    },
                    [_vm._v("Created")]
                  )
                : this.invoice.Status == 1
                ? _c(
                    "span",
                    {
                      staticClass: "btn-selection",
                      staticStyle: {
                        "border-color": "#ffc9c9",
                        "background-color": "#ffe2e2",
                        color: "#9f0712",
                      },
                    },
                    [_vm._v("Not Reconciled")]
                  )
                : this.invoice.Status == 2
                ? _c(
                    "span",
                    {
                      staticClass: "btn-selection",
                      staticStyle: {
                        color: "rgb(161, 98, 7)",
                        "background-color": "rgb(254, 252, 232)",
                        "border-color": "rgb(254, 240, 138)",
                      },
                    },
                    [_vm._v("Partially Paid")]
                  )
                : this.invoice.Status == 3
                ? _c(
                    "span",
                    {
                      staticClass: "btn-selection",
                      staticStyle: {
                        "border-color": "rgb(185, 248, 207)",
                        "background-color": "rgb(240, 253, 244)",
                        color: "rgb(0, 130, 54)",
                      },
                    },
                    [_vm._v("Reconciled")]
                  )
                : _c("span", [_vm._v("—")]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: " mt-2rem" }),
          _vm._v(" "),
          _c("div", { staticClass: "grid-2-1 gap-2rem mt-2rem" }, [
            _c("div", { staticStyle: { display: "grid", gap: "1rem" } }, [
              _c("span", { staticClass: "subtitle" }, [
                _vm._v("Payment Information"),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("small", [_vm._v("IBAN")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "filter-item-content",
                    staticStyle: { "border-color": "#ebe6e7" },
                  },
                  [
                    _c("span", { staticStyle: { color: "#000" } }, [
                      _vm._v(
                        _vm._s(
                          this.invoice.VIBAN.replace(/(.{4})(?!$)/g, "$1 ")
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("small", [_vm._v("Required Reference")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "filter-item-content",
                    staticStyle: {
                      "border-color": "#fef08a",
                      "background-color": "#fefce8 !important",
                      color: "#000",
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(this.invoice.InvoiceIdentifier))])]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { display: "grid", gap: "0.5rem" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "baseline",
                  },
                },
                [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v("Order Details"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-dark",
                      staticStyle: {
                        "background-color": "#2b7fff",
                        "border-color": "#2b7fff",
                        height: "3rem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.checkPaymentStatus()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-regular fa-refresh" }),
                      _vm._v(" Check Payment Status"),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("small", [_vm._v("Created:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        new Date(this.invoice.PaymentDate).toLocaleDateString()
                      )
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: " mt-2rem" }, [
            _c("span", { staticClass: "subtitle" }, [_vm._v("Order Timeline")]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-1-1-1 mt-2rem" }, [
              _c("div", [
                _vm._m(9),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "grid",
                      "justify-items": "center",
                      "margin-top": "1rem",
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#00a63e" } }, [
                      _vm._v("Order Created"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "#99a1af" } }, [
                      _vm._v(
                        _vm._s(
                          new Date(
                            this.invoice.PaymentDate
                          ).toLocaleDateString() +
                            ", " +
                            new Date(
                              this.invoice.PaymentDate
                            ).toLocaleTimeString()
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "0.25rem",
                    },
                  },
                  [
                    _c("div", {
                      staticStyle: {
                        "border-bottom": "2px solid #0000001a",
                        width: "100%",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        style: {
                          "border-radius": "50%",
                          "background-color":
                            this.invoice.Status == 2
                              ? "rgb(161, 98, 7)"
                              : this.invoice.Status == 3
                              ? "00c951"
                              : "#2b7fff",
                          padding: "0.75rem",
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-clock",
                          staticStyle: {
                            color: "white",
                            "font-size": "1.5rem",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: {
                        "border-bottom": "2px solid #0000001a",
                        width: "100%",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "grid",
                      "justify-content": "center",
                      "margin-top": "1rem",
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#155dfc" } }, [
                      _vm._v(
                        _vm._s(
                          this.invoice.Status == 2
                            ? "Partially paid"
                            : this.invoice.Status == 3
                            ? "Payment received"
                            : "Waiting for Payment"
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "0.25rem",
                    },
                  },
                  [
                    _c("div", {
                      staticStyle: {
                        "border-bottom": "2px solid #0000001a",
                        width: "100%",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        style: {
                          "border-radius": "50%",
                          "background-color":
                            this.invoice.Status == 2
                              ? "rgb(161, 98, 7)"
                              : this.invoice.Status == 3
                              ? "00c951"
                              : "#0000001a",
                          padding: "0.75rem",
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-check",
                          staticStyle: {
                            "font-weight": "bold",
                            color: "#99a1af",
                            "font-size": "1.5rem",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: {
                        "border-bottom": "2px solid #0000001a",
                        width: "100%",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm._m(10),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-1-1 gap-1rem mt-2rem" }, [
              _c(
                "button",
                {
                  staticClass: "btn-outline-light btn",
                  on: {
                    click: function ($event) {
                      return _vm.viewOrder()
                    },
                  },
                },
                [_vm._v("View All Orders")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-outline btn-dark",
                  staticStyle: {
                    "background-color": "#2b7fff",
                    "border-color": "#2b7fff",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createNewOrder()
                    },
                  },
                },
                [_vm._v("Create New Order")]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "filter-item-title" }, [
      _vm._v("Client Number "),
      _c("a", { attrs: { id: "info-clientNumber-link", href: "#" } }, [
        _c("i", { staticClass: "fa-light fa-circle-question" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "filter-item-title" }, [
      _vm._v("Order Reference (optional) "),
      _c("a", { attrs: { id: "info-reference-link", href: "#" } }, [
        _c("i", { staticClass: "fa-light fa-circle-question" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "span",
        {
          staticClass: "btn-empty",
          staticStyle: {
            color: "#008236",
            "background-color": "#dcfce7",
            border: "none",
            "font-size": "0.9rem",
          },
        },
        [_vm._v("Instant")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "btn-empty",
          staticStyle: {
            color: "#1d4ed8",
            "background-color": "#dbeafe",
            border: "none",
            "font-size": "0.9rem",
          },
        },
        [_vm._v("Automated")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card p-6 disabled",
        staticStyle: { display: "flex", "flex-direction": "row", gap: "1rem" },
      },
      [
        _c("i", {
          staticClass: "fa-regular fa-circle-check",
          staticStyle: {
            "background-color": "#4a5565",
            "border-radius": "0.625rem",
            padding: "1rem",
            height: "3rem",
            color: "white",
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          },
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { display: "grid" } }, [
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("E-mandate"),
          ]),
          _vm._v(" "),
          _c("small", [_vm._v("Automated direct debit")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card p-6 disabled",
        staticStyle: { display: "flex", "flex-direction": "row", gap: "1rem" },
      },
      [
        _c("i", {
          staticClass: "fa-regular fa-credit-card",
          staticStyle: {
            "background-color": "#4a5565",
            "border-radius": "0.625rem",
            padding: "1rem",
            height: "3rem",
            color: "white",
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          },
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { display: "grid" } }, [
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("Credit Card"),
          ]),
          _vm._v(" "),
          _c("small", [_vm._v("Visa, Mastercard, Amex")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("small", [_vm._v("Expected Processing Time")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-item-content bordered",
          staticStyle: { display: "flex", gap: "1rem" },
        },
        [
          _c("span", [_vm._v("Instant: ~1 minute")]),
          _vm._v(" "),
          _c("div", { staticStyle: { "border-left": "2px solid #0000001a" } }),
          _vm._v(" "),
          _c("span", [_vm._v("Regular: 2-3 days")]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-container" }, [
      _c("i", {
        staticClass: "fa-light fa-circle-exclamation",
        staticStyle: { color: "#155dfc" },
      }),
      _vm._v(" "),
      _c("span", [
        _c(
          "span",
          { staticStyle: { color: "#1c398e", "font-weight": "bold" } },
          [_vm._v("Important:")]
        ),
        _vm._v(" This IBAN is "),
        _c(
          "span",
          { staticStyle: { color: "#155dfc", "font-weight": "bold" } },
          [_vm._v("unique to your account")]
        ),
        _vm._v(" and enables automatic payment reconciliation."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "border-bottom": "1px solid #0000001a",
          padding: "0.5rem 0rem",
          "margin-bottom": "0.5rem",
        },
      },
      [
        _c("span", { staticStyle: { color: "#4a5565" } }, [_vm._v("Type:")]),
        _vm._v(" "),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("One-time"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c("small", [_vm._v("Customer Type:")]),
        _vm._v(" "),
        _c("span", [_vm._v("One-time")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          gap: "0.25rem",
        },
      },
      [
        _c("div", {
          staticStyle: { "border-bottom": "2px solid #0000001a", width: "50%" },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "border-radius": "50%",
              "background-color": "#00c951",
              padding: "0.75rem",
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
            },
          },
          [
            _c("i", {
              staticClass: "fa-regular fa-check",
              staticStyle: {
                "font-weight": "bold",
                color: "white",
                "font-size": "1.5rem",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticStyle: { "border-bottom": "2px solid #0000001a", width: "50%" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "grid",
          "justify-items": "center",
          "margin-top": "1rem",
        },
      },
      [
        _c("span", { staticStyle: { color: "#99a1af" } }, [
          _vm._v("Payment Confirmation"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }